import { logout, refresh, verify } from '@/api/security';
import router from '@/router';
import jwt_decode from 'jwt-decode';

var timer;

export function getTokenSession(session){
    try {
        return jwt_decode(session.token);
    } catch (err) {
        clearLocalStorage();
        router.push('/');
    }
}

export function getSession () {
    return JSON.parse(localStorage.getItem('session'));
}

export function clearLocalStorage() {
    stopTimer();
    localStorage.removeItem('email');
    localStorage.removeItem('session');
    localStorage.removeItem('time_difference');
}

export function checkTimer() {
    const session = getSession();
    if (session && session.token) {
        // get token
        let token = '';
        token = getTokenSession(session);
        // get time diff
        const timeDiff = Number(localStorage.getItem('time_difference'));
        // get expiration time
        let expDate = new Date(0);
        expDate.setUTCSeconds(token.exp);
        let expTime = expDate.getTime();
        if (timeDiff > 0) {
            expTime = expTime - timeDiff;
        } else {
            expTime = expTime + Math.abs(timeDiff);
        }
        // set countdown time
        const thirtySec = 30000;
        const cdTime = expTime - thirtySec;
        if (timer) {
            clearInterval(timer);
        }
        timer = setInterval(() => {
            // get local time
            const localDate = new Date();
            const localTime = localDate.getTime();
            const countdown = localTime + thirtySec;
            const diff = cdTime - countdown;
            if (diff <= 0) {
                logoutAndClean();
                router.push('/');
            }
        }, thirtySec);
    }
}

export function stopTimer() {
    if (timer) {
        clearInterval(timer);
    }
}

export function setSession(data) {
    localStorage.setItem('session', JSON.stringify(data));
    const payload = getTokenSession(data);
    let local = new Date();
    let server = new Date(0);
    server = server.setUTCSeconds(payload.orig_iat);
    local = local.getTime();
    const timeDiff = server - local;
    localStorage.setItem('time_difference', timeDiff.toString());
    localStorage.setItem('email', data.user.email);
    checkTimer();
}

export function logoutAndClean() {
    return logout().finally(() => {
        clearLocalStorage();
    })
}

export async function isLoggedIn() {
    const session = getSession();
    let tokenIsValid = false;
    if ( typeof session !== 'undefined' && session !== null ) {
        try {
            const res = await verify(session.token);
            tokenIsValid = res?.status === 200;
        } catch (error) {
            try {
                const res = await refresh(session.token);
                tokenIsValid = res?.status === 200;
                setSession(res.data);
            } catch (error) {
                // pass
            }
        }
        if ( !tokenIsValid ) clearLocalStorage();
            return tokenIsValid;
    }
}
